(() => {
  const initializeTrack = (track) => {
    if (track.dataset.mouseDragReady === 'true') return;
    track.dataset.mouseDragReady = 'true';

    let pointerDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;
    let suppressClick = false;

    const updateDraggableState = () => {
      track.classList.toggle('is-mouse-draggable', track.scrollWidth > track.clientWidth + 2);
    };

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || track.scrollWidth <= track.clientWidth + 2) return;

      pointerDown = true;
      moved = false;
      suppressClick = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      track.setPointerCapture(event.pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      if (!pointerDown || event.pointerType !== 'mouse') return;

      const distance = event.clientX - startX;
      if (!moved && Math.abs(distance) < 5) return;

      moved = true;
      event.preventDefault();
      track.classList.add('is-dragging');
      track.scrollLeft = startScrollLeft - distance;
    });

    const endDrag = (event) => {
      if (!pointerDown) return;
      pointerDown = false;
      suppressClick = moved;
      track.classList.remove('is-dragging');

      if (track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }

      window.setTimeout(() => {
        suppressClick = false;
      }, 0);
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', () => {
      pointerDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    track.addEventListener('dragstart', (event) => event.preventDefault());

    updateDraggableState();
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateDraggableState).observe(track);
    } else {
      window.addEventListener('resize', updateDraggableState, { passive: true });
    }
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-collection-track]').forEach(initializeTrack);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
